"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actionsRegistry_1 = require("./actionsRegistry");
function handleActions(handlers, options) {
    var initialState = options.initialState;
    if (!('strict' in options))
        options.strict = true;
    var flattenHandlers = (function (handlers) {
        var result = {};
        Object.keys(handlers).forEach(function (type) {
            if (type.slice(-1) === ',') {
                var multipleTypes = type.slice(0, -1);
                var types = multipleTypes.split(',');
                types.forEach(function (splittedType) {
                    if (options.strict && !actionsRegistry_1.default.has(splittedType))
                        console.warn("Unknown action " + splittedType);
                    result[splittedType] = handlers[type];
                });
            }
            else {
                if (options.strict && !actionsRegistry_1.default.has(type))
                    console.warn("Unknown action " + type);
                result[type] = handlers[type];
            }
        });
        return result;
    })(handlers);
    return function (state, action) {
        if (state === void 0) { state = initialState; }
        if (flattenHandlers[action.type]) {
            return flattenHandlers[action.type](state, action);
        }
        else {
            return state;
        }
    };
}
exports.default = handleActions;



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions-helpers/lib/handleActions.js
// module id = ./node_modules/redux-actions-helpers/lib/handleActions.js
// module chunks = 0